import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigationType } from "react-router-dom";
import { cn } from "@/lib/utils";

/**
 * iOS-style page transition. On PUSH: incoming view slides in from the right.
 * On POP (back gesture / browser back): incoming view slides in from the left.
 * Respects prefers-reduced-motion (fades instead).
 */
export function MobilePageTransition({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  const navType = useNavigationType();
  const [displayKey, setDisplayKey] = useState(location.key);
  const [direction, setDirection] = useState<"push" | "pop" | "none">("none");
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (location.key === displayKey) return;
    setDirection(navType === "POP" ? "pop" : "push");
    setDisplayKey(location.key);
    // strip the direction class after animation finishes
    const id = window.setTimeout(() => setDirection("none"), 260);
    return () => window.clearTimeout(id);
  }, [location.key, navType, displayKey]);

  return (
    <div
      ref={containerRef}
      key={displayKey}
      className={cn(
        "min-h-full",
        direction === "push" && "animate-[mobileSlideInRight_240ms_ease-out]",
        direction === "pop" && "animate-[mobileSlideInLeft_240ms_ease-out]"
      )}
    >
      {children}
    </div>
  );
}

export default MobilePageTransition;
